const HowItWorks = () => {
  return (
    <section className="container mx-auto my-20">
      <h3 className="font-bold text-3xl text-[#1A1D21] text-center mb-10">
        How Taram platform works
      </h3>

      <div className="flex flex-wrap justify-center gap-8 text-white">
        <div className="flex items-center ">
          <div className="bg-[#42474D] shadow-md rounded-lg overflow-hidden w-[309px] h-[306px] p-8">
            <p className="font-bold text-3xl ml-4 py-2">1</p>
            <div className="flex items-center gap-4 mb-2">
              <svg
                width={45}
                height={49}
                viewBox="0 0 45 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <path fill="url(#pattern0_3125_4559)" d="M0 0H45V49H0z" />
                <defs>
                  <pattern
                    id="pattern0_3125_4559"
                    patternContentUnits="objectBoundingBox"
                    width={1}
                    height={1}
                  >
                    <use
                      xlinkHref="#image0_3125_4559"
                      transform="matrix(.01089 0 0 .01 -.044 0)"
                    />
                  </pattern>
                  <image
                    id="image0_3125_4559"
                    width={100}
                    height={100}
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABNNJREFUeAHtnU/oVUUUx1/hokRMLUON/liLFtHCpWg7FUFsY6RBYRtBEvpDYeJCxEUmiqALRdGVEkLmLmoRhKIL/6RISZGQ/aFFRCaalWl+uifm4eVxr7/75s0977zfnIHHmzd3Zs6Zz/e+e++798y8TseTE3ACTsAJOAEn4AScgBNwAk7ACTgBJ+AEoggADwDPA9uAT4CLwGXgZnhJXspk21ZgKTA5ypg3qicALAQOA3/Rf5I2HwIL6i34lkYEgOeAU/1rUNviJDCvkXGvdIcAcD+wB7hdizZ+g/S5G7jvjkXP1RIAHgPOxfNu3PIs8GitI76h0wGeBC41Rjp4xe+A2c6+ggDwIPDt4Iz77kFEmV7hUr5FwL3A532jTNfgM/EhXwV6Rg68nY5tdE9v9riV50dgFnA9GmO6hn8UV3Yz81ShNOpCkL3pmA7c066Sa/ll5WQK/D0wxnQdiC8P56dEGHEhxrp0LJP1tDZnQTR+APar1OksBQEe75eUUn25tfJIdqIALysBjjGzIkdBdsSQUmqzPUdBPlWCG2Pm4xwF+SaGlFKbCzkK8psS3Bgzv+YoSMzj2Bi4MW3+zFEQCUywmm7mKIgfsiypDsiDIavpoiVWKr4AZ6yqIZEuKhAsGQE+MCzIAUusVHwB1hsW5F0VCJaMhDBPq5osscRKxZcQZfKvQUVuAdNUIFgzkjhMNJW2J6xxUvOnCL3ZlIpiwn42qAGwZgiYkxBkqq6etcZJ1R+lON6mYp1RHbxFY8WEm9eb0lKot8YiI1WfgKnAVQXYY5kQH6aqDt6qsWI+yJaxaCls32yVj7pfwENFfO81Beh1JiSUNd8AuSrFixlN79fRUih/r8qnrMuAicD3CvB7TfxUzOqdlDX8usEDy3tpKXx+oc4fL+/8P63tiIIIXRMfOfQxCABTlOYZ/ig3OMdwxzcLAZlLDtzo7sYtvEvfc512HwSAFUAbt+clmPqVPlzxql0CwGstfDve6vbv7xEEUgsS4YI3KRNwQco0DORdEAMilF1wQco0DORdEAMilF1wQco0DORdEAMilF1wQco0hpyXtUdSCwLMGPKwRtd88Yy7jZm6+c2wTbELFA+rXm3pXpbcH1uZwscs+gAmhDVQ2rix2D0CSvzuWrGVBdSYQQL3AIuLhZJlcUqt9AWwSGzH+Dwu24RVSN8AvtJSocLOl4D4kOcqpcATAcDxltbmrWDeuOgCsBF4elx+A7qDKpb7fiYM1PLcwl7VRBwJT5o/8oe1cE6QpcJ3Aj/0jnQEP0uIklyGz+/uZCPxHmJ15QrG8lomg+4PXwPvyL81mBUlCCETcK4MOtoRav97OAxPMSVMmMD58wiBTO3qL8CyoYsS/sXgUOrRjXB/B4f2rwshoO3YCMNry/Wj6ueWEBgtv3I9VRM4LUcPtUNY8Yt2f7UfXloisEdFEOClklHP3p3Ai62KEk7iMp/CUzMCcuU5sTVRgDXN/PBaJQKr2xTkfMmQZ5sRONuKIMBTzex7rQoC6f/nClhdYciLmhFYlfxbAuxrZttrVRDY24Yg8jDJUxyBo20IMh6eacThHLzVpTYEsbAeyeBohtPDlTYEsbwS9XAwN7f6T3JBvEMn4AScgBNwAk7ACTgBJ+AEnIATcAJOQIHAf6/D0Sssoda5AAAAAElFTkSuQmCC"
                  />
                </defs>
              </svg>
              <h3 className="text-[22px] font-bold flex items-center">
                Registration
              </h3>
            </div>
            <div className=" flex text-center text-[15px] justify-center mt-5">
              <p>
                Customer signs up to Taram’s platform and undergoes e-KYB
                process.
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center">
          <div className="bg-[#42474D] shadow-md rounded-lg overflow-hidden w-[309px] h-[306px] p-4">
            <div className="p-3">
              <p className="font-bold text-3xl ml-4 py-2">2</p>
              <div className="flex items-center gap-4 mb-2">
                <svg
                  width={48}
                  height={48}
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <path fill="url(#pattern0_3125_4564)" d="M0 0H48V48H0z" />
                  <defs>
                    <pattern
                      id="pattern0_3125_4564"
                      patternContentUnits="objectBoundingBox"
                      width={1}
                      height={1}
                    >
                      <use
                        xlinkHref="#image0_3125_4564"
                        transform="scale(.01)"
                      />
                    </pattern>
                    <image
                      id="image0_3125_4564"
                      width={100}
                      height={100}
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABGFJREFUeAHtnTuI1UAUhkXBx4KFsDaK2ooiCDYrWKiIW62VWyqIoI2Fi4WlWwqi/bpWdi6CpQv21goLduKjErVREMXHZwYSNtybmztJZiZnJidNciczZ2a+k0zOzT9JtmzRRQkoASWgBJSAElACSkAJKAEloASUgBJQAkpACSgBJaAElIASUAIyCAAzwBngAnBQRqsG2ApgDlgFvrG5/AUeAjsHiCR8l4FZYAnY2PRB5dZK+NYNpEZgKzAPrAG/KvGPJ/4BDgwEUZhuZsPRfuA28Hact1XKQpiWJlwLsB1YzK4P64C5HnRZTieMym/XsuHoCPAA+NzFA6Wy5kI/47fViVkHduVnwwvgXwmmi83VxHD56w5wAlgZCVddOKFsY85fDxKwDOwBrgGvytQ8bb9JAJn7LuTh6jngMfDDE/wqs0vuexOxRQfhahVk2zTzP2VvxPjcND0PVxfyP2+/bel5yPfETY8itQIczu4b3QU+eYDbxuT5SFG2b7bncLWNE4oyH4Bt7XsWWclA4WoBt836TmRImzc3cLjaxglFGXOb5VDzHkZQosdwtYDbZv08ArTNmthzuNrGCeUyF5v1VmhuQeFqGW7T7S/ADqGI7ZolMFxt6oRy/vt2vRaWS3C4WobbZvuoMNT1zSmFq9/b9FZ4mZf1vReyN6Jwtau/rwpBPt6MSMPVLg4xZ/zucRI9p5jJYcAy8L5L7yIs+6hn9OPVAzcbTI2JkHltk0+OE+kxBTjuQYuuJSBo50aP6KurBm4JAhS6KfJUweyacSU0BSH1GVVwtvow7THVRBjAOyGQQjZjrUfs9VWbW87AU8DMZR3KMl9PRcDebAr+vjz0NTfaUl7iUgXNcxHZ5OTLwOtEvRKvKgicEjALxOVxkYYqmNBwti7g6uCuCQkMZ4vuaAizFOFwFr8qaHMMRDScxakK2jihKk8Ew1lcqmAV5LZpAoezOFTBtsBtywkazuSqgrYwXebreTiTqQq6BNzFFnDJ5T89C1vyVMEuAH2UDXxbRp8VnOZE4LrFke0iiz4rOM0ZZn/+9p2vLohPsSFPFbQB1Ece4N4UmF1367OCTRybC2M+RTG5qmATUCHzAs+6ngY15eWrgiFh29QFnK0B2mVXXKqgDaxQeTyFwPGqgqHAT6rHQwichio4CZjvdA8hcFqqoG8HVNl3HAKnqwpWwfOR5jAEHoYq6MMJozYdhcDDUgVHIbr87SgEHq4q6NIZha2OIbCqggVIV+uOIbCqgq4cUdjpEAKrKlhAdL1uGQKrKujaEYW9liGwrGcFi86ksm4YAqsq6NvxDUNgVQV9O8TYtwyBVRUM4YzcITYTIVQVDOgQ8xmiaRMhVBUM5ZD8LKmbCPFxUG8QDQl+Ul1TQuDlSeU03SOB/JHtUX39p35NzSP0OtP5WVJ+uYH5TsiNujK6zzOB/I0T5jUg5utqxzxXp+aVgBJQAkpACSgBJaAElIASUAJKQAkoASWgBJTA4Aj8B7RaxDyGlmB+AAAAAElFTkSuQmCC"
                    />
                  </defs>
                </svg>{" "}
                <h3 className="text-[22.13px] font-bold flex ">
                  Select Services
                </h3>
              </div>
              <div className="text-center text-[15px] mt-5">
                <p>
                  Customer selects needed services and then selects appropriate
                  quotations from vendors, upon which the vendors’ approval is
                  required.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center ">
          <div className="bg-[#42474D] shadow-md rounded-lg overflow-hidden w-[309px] h-[306px] p-4">
            <div className="p-3">
              <p className="font-bold text-3xl ml-4 py-2">3</p>
              <div className="flex items-center gap-4 mb-2">
                <svg
                  width={56}
                  height={52}
                  viewBox="0 0 56 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <path fill="url(#pattern0_3125_4570)" d="M0 0H56V52H0z" />
                  <defs>
                    <pattern
                      id="pattern0_3125_4570"
                      patternContentUnits="objectBoundingBox"
                      width={1}
                      height={1}
                    >
                      <use
                        xlinkHref="#image0_3125_4570"
                        transform="matrix(.01 0 0 .01077 0 -.038)"
                      />
                    </pattern>
                    <image
                      id="image0_3125_4570"
                      width={100}
                      height={100}
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA/pJREFUeAHtnGFu1DAQhZd7FFQ4CFT8RogDFE6B6F8ECHGwFu7QwlHgwaRekzWJndixMx5epGiddez4fbOzSZzJHA5cSIAESIAESIAESIAESIAESIAESIAESIAESOA/IwDgCYDXAN4CuEqsso/s+1gbpu51AHgO4Bvyl68ALvY2TPc6ADwA8BnAr3xb+JbSxyfps7VhrOg4OGN4ohsVPu5gEPlRbb201eHcewvPCEFIn89aGcWKDvGOknNGaIRw+6ahQfrXAeA8JFhhu/rVlxUd4h1vKhgg7PKytpdY0SEGkXuM2svVGoMAeCjryjbqdKwZv98XwPva1pBj+ANGCgBe/bnB/DEaz3cALyNNfJUmHX5QOQUtQpwxpq70fi4xihYdOTY4aaNBiLuZG3vGyEmG4t3JoCc2NOiYGNb6rzQIAfAotMDEdvScokHHevoTLTQIWWiQs4nh+6806PCDKSloEQJATuBzy21KoxYdqXEm67UIkRM3ADmBh4t89yIlRIuO1DiT9ZqEOKPcjSxyu8QYIlKTjiT02A6NbgzfxcYQ1gE4kzX8PratUUdsvLN1VqYcrOgQV+fk4ug/MlGsPkk6eA4Aeexaa7medc+NK6zoEC+52OjRbWhUmQp5ujH32e6s6BgEumfgIdDS7UWTirOEMyqs6BAvkSAHCUyYmuBbaxjp48OOQQ7d6/C/RXkGDuBmrQVG+1+3/JvyAw8KVnR4We7q69Jd338BEFvl4ZDse+47UFKwokMJTg6DBEiABEiABEiABEiABHYhkBPEtstAEwftXkdJEFuCTdNqEzpKg9iaEo8czISOLYLYIoyaVVnRIbPAxUFszahHDmRFx1KDrApIiHCrVrXQIOp1DIBKg9iqUV7ZsRUd4iVFQWwruVXb3YqOAVBJEFs1whkdW9HhpecEsfnGigpWdChCyqGQAAmQAAmQAAmQAAmQQDGB7jOxOQLd6+g+E9tfQ/SdGc89L2BGuVGQsgs83yUznkwg9p+J7f7lz/51WMnEZkWHeEf/mdjuvaN/HXzp8/Skkdiq/9KnldeJreiQvyt1mdhygtg06si6GdSUkqIkiE2TjixDHBtpEVIaxKZFx5Fr9qcGIVsEsWnQkW2EcUMNQhbGTDGjXOIScE11NIHAQoNEg9g0/LDGP/TsshYhpUFsWnRkG+LYUIuQ0iA2LTqOXLM/NQkpCWLTpCPbGNKw0Q0VM8ottZKVKQcrOsRDmFFu+fVi/clF97fFjHJpozTLjCdewoxycYM0zYw3nG6sZGKzokO8hBnl/vWS3TLj+YsyK5nYrOgYG0auvphRzhNhgQRIgARIgARIgARIgARIgARIgARIgARIgARsE/gNotRtnGTlWWYAAAAASUVORK5CYII="
                    />
                  </defs>
                </svg>{" "}
                <h3 className="text-[22.13px] font-bold flex items-center">
                  Smart Contract
                </h3>
              </div>
              <div className=" flex text-center text-[15px] justify-center mt-5">
                <p>
                  Upon vendors’ approval of quotes, a smart contract per terms
                  between vendors and customer is created.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center ">
          <div className="bg-[#42474D] shadow-md rounded-lg overflow-hidden w-[309px] h-[306px] p-4">
            <div className="p-2">
              <p className="font-bold text-3xl ml-2 py-2">4</p>
              <div className="flex items-center gap-4 mb-2">
                <svg
                  width={38}
                  height={39}
                  viewBox="0 0 38 39"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <path fill="url(#pattern0_3125_4576)" d="M0 0H38V39H0z" />
                  <defs>
                    <pattern
                      id="pattern0_3125_4576"
                      patternContentUnits="objectBoundingBox"
                      width={1}
                      height={1}
                    >
                      <use
                        xlinkHref="#image0_3125_4576"
                        transform="matrix(.01026 0 0 .01 -.013 0)"
                      />
                    </pattern>
                    <image
                      id="image0_3125_4576"
                      width={100}
                      height={100}
                      xlinkHref="data:image/png;base64,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"
                    />
                  </defs>
                </svg>{" "}
                <h3 className="text-[22.13px] font-bold flex items-center">
                  Service Execution
                </h3>
              </div>
              <div className=" flex text-center text-[15px] justify-center mt-4">
                <p>
                  Sequential execution of availed services, payment settlement
                  per contract, and digital title & documents’ exchange from
                  vendor to customer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default HowItWorks;
